import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {MegaHeaderModuleController} from "../mega-header-module.controller";

export class MegaHeaderModuleProps extends BaseModuleProps {
  controller: MegaHeaderModuleController;
}
